// export const Common_URL = "http://52.168.15.130:7010/edge-service/user-service";
// export const System_URL =
//   "http://52.168.15.130:7010/edge-service/system-service";
// // export const Location_Master_URL = "http://172.16.10.103:9000/location-service";
// export const Auth_URL = "http://52.168.15.130:7013/user-service";
// export const UserService_URL = "http://52.168.15.130:7006/user-service";

// export const Location_Master_URL =
//   "http://52.168.15.130:7011/location-service";

// export const CompanyManagementService_URL =
//   "http://52.168.15.130:7005/company-service";

// export const SystemService_URL = "http://52.168.15.130:7002/system-service";

// export const Server_IP = "http://52.168.15.130";

////////////////////////////PROFILING FOR DEPLOYMENT//////////////////////////

export const Common_URL = process.env.REACT_APP_COMMON_URL_API;
export const System_URL = process.env.REACT_APP_SYSTEM_URL_API;
export const Auth_URL = process.env.REACT_APP_AUTH_URL_API;
export const UserService_URL = process.env.REACT_APP_USERSERVICE_URL_API;
export const Location_Master_URL =
  process.env.REACT_APP_LOCATION_MASTER_URL_API;
export const CompanyManagementService_URL =
  process.env.REACT_APP_COMPANY_MANAGEMENT_SERVICE_URL_API;
export const SystemService_URL = process.env.REACT_APP_SYSTEM_SERVICE_URL_API;
export const Server_IP = process.env.REACT_APP_SERVER_IP_API;
export const EdgeService_URL = process.env.REACT_APP_EDGE_SERVICE_IP_API;
export const Auth_OTP_URL = process.env.REACT_APP_OTP_AUTH_URL_API;
export const ConsentManagementService_URL =
  process.env.REACT_APP_CONSENT_MANAGEMENT_SERVICE_URL_API;
export const AssetManagementService_URL =
  process.env.REACT_APP_ASSETMANAGEMENT_SERVICE_URL_API;
export const CompanyService_URL =
  process.env.REACT_APP_COMPANY_MANAGEMENT_SERVICE_URL_API;
export const RequestManagement_URL =
  process.env.REACT_APP_REQUEST_MANAGEMENT_API;
export const RopaManagementService_URL =
  process.env.REACT_APP_ROPAMANAGEMENT_SERVICE_URL_API;
export const UserManagementService_URL =
  process.env.REACT_APP_USERSERVICE_URL_API;